import { Button, ButtonProps } from '@mui/material';
import { primaryBtnSx } from './ds';

interface ActionButtonProps extends Omit<ButtonProps, 'variant'> {
  children: React.ReactNode;
}

const ActionButton = ({ children, sx, ...rest }: ActionButtonProps) => (
  <Button variant="contained" sx={{ ...primaryBtnSx, ...sx }} {...rest}>
    {children}
  </Button>
);

export default ActionButton;
